import React, {useContext} from "react";
import {Route, Redirect,} from "react-router-dom";
import UserContext from "./../context/UserContext"

export default function MasterRoute({component: Component, ...rest}) {
    const {userClaims} = useContext(UserContext);
    return (
        <Route {...rest} render={props => (
            userClaims === 'master' ?
                <Component {...props} />
                : <Redirect to="/"/>
        )}/>
    );
}
